export default "__VITE_ASSET__flwy78Nx__"